export const Colors = {
    PROFILE_RED: "#C31230",
    PROFILE_YELLOW_DARK: "#eba003",
    PROFILE_YELLOW: "#FCBA30",
    PROFILE_YELLOW_LIGHT: "#FEF3D8",
    BLACK: "#000000",
    WHITE: "#FFFFFF",
    GRAY_DARKEST: "#222222",
    GRAY_DARK: "#595959",
    GRAY: "#BBBBBB",
    GRAY_LIGHT: "#F2F2F2",
    GRAY_LIGHT_DISABLED: "#E0E0E0",
    GRAY_LINEAR: "linear-gradient(180deg, #F7F7F7 0%, #DCDCDC 100%)",
    ALERT_SUCCESS: "#3D6946",
    ALERT_SUCCESS_LIGHT: "#D9F5E0",
    ALERT_ERROR: "#C31230",
    ALERT_ERROR_LIGHT: "#FFEFF2",
    ALERT_WARNING: "#FFF3B2",
    //New colors 2024
    PROFILE_RED_2024: "#ff0033",
    DARK_RED_2024: "#600032",
    LIGHT_RED_2024: "#FF716D",
    DARK_BLUE_2024: "#0000FF",
    TURQUOISE_2024: "#00EAFF",
    DARK_GREEN_2024: "#003E2D",
    LIGHT_GREEN_2024: "#00F289",
    GRAY_2024: "#E0E0E0",
    BLACK_2024: "#222222",
    WHITE_2024: "#FFFFFF",
    DARK_WHITE_2024: "#F4F4F4",
    SUCCESS_GREEN: "#48c072",
    //New colors 2025
    TEXT: "#373843",
};
export default Colors;
//# sourceMappingURL=index.js.map